import { Skeleton } from "@ui/shad"

export function NoteDialogSkeleton() {
  return (
    <>
      <div className="flex h-10 flex-row items-center justify-between space-y-0 border-b pr-2 pl-4" />
      <div className="h-[480px] p-6 pt-12">
        <div className="space-y-4">
          <Skeleton className="h-8 w-1/2" />
          <div className="space-y-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-4 w-5/6" />
            <Skeleton className="h-4 w-2/3" />
            <Skeleton className="h-4 w-4/5" />
          </div>
        </div>
      </div>
    </>
  )
}
